var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 8.5C10.5 9.16304 10.2366 9.79893 9.76777 10.2678C9.29893 10.7366 8.66304 11 8 11C7.33696 11 6.70107 10.7366 6.23223 10.2678C5.76339 9.79893 5.5 9.16304 5.5 8.5C5.5 7.83696 5.76339 7.20107 6.23223 6.73223C6.70107 6.26339 7.33696 6 8 6C8.66304 6 9.29893 6.26339 9.76777 6.73223C10.2366 7.20107 10.5 7.83696 10.5 8.5Z",
    fill: "#1F242E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.5C0 8.5 3 3 8 3C13 3 16 8.5 16 8.5C16 8.5 13 14 8 14C3 14 0 8.5 0 8.5ZM8 12C8.92826 12 9.8185 11.6313 10.4749 10.9749C11.1313 10.3185 11.5 9.42826 11.5 8.5C11.5 7.57174 11.1313 6.6815 10.4749 6.02513C9.8185 5.36875 8.92826 5 8 5C7.07174 5 6.1815 5.36875 5.52513 6.02513C4.86875 6.6815 4.5 7.57174 4.5 8.5C4.5 9.42826 4.86875 10.3185 5.52513 10.9749C6.1815 11.6313 7.07174 12 8 12Z",
    fill: "#1F242E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIcon);
export default __webpack_public_path__ + "static/media/ViewIcon.a3784b2bd81926ea38865964b999f0a8.svg";
export { ForwardRef as ReactComponent };